import React, { useState } from "react";
import { FaToggleOn, FaToggleOff, FaShieldAlt } from "react-icons/fa";
import { useAuth } from "../../context/AuthContext";
import { useModuleSettings } from "../../context/ModuleSettingsContext";
import { isPlatformAdmin } from "../../constants/roles";
import "./ModuleSettings.css";

export default function ModuleSettings() {
  const { user } = useAuth();
  const { modules, loading, error, setEnabled, refresh } = useModuleSettings();
  const [busyKey, setBusyKey] = useState(null);
  const [saveError, setSaveError] = useState("");

  const isAdmin = isPlatformAdmin(user?.role);

  if (!isAdmin) {
    return (
      <div className="modset-forbidden">
        <FaShieldAlt />
        <p>This section is only available to Platform Admins.</p>
      </div>
    );
  }

  const onToggle = async (key, current) => {
    setBusyKey(key);
    setSaveError("");
    try {
      await setEnabled(key, !current);
    } catch (err) {
      setSaveError(err.message || "Failed to update");
      // re-fetch in case of partial failure
      refresh();
    } finally {
      setBusyKey(null);
    }
  };

  return (
    <div className="modset-page">
      <div className="modset-header">
        <h2>Module Settings</h2>
        <p className="modset-sub">
          Toggle modules on or off. Disabled modules are hidden from the sidebar
          and the home page for all users until re-enabled.
        </p>
      </div>

      {loading && <div className="modset-loading">Loading…</div>}
      {error && <div className="modset-error">{error}</div>}
      {saveError && <div className="modset-error">{saveError}</div>}

      <div className="modset-list">
        {modules.map((m) => {
          const enabled = !!m.enabled;
          const busy = busyKey === m.module_key;
          return (
            <div key={m.module_key} className={`modset-row ${enabled ? "is-on" : "is-off"}`}>
              <div className="modset-row-main">
                <div className="modset-row-label">{m.label}</div>
                <div className="modset-row-key">{m.module_key}</div>
                {m.updated_by && (
                  <div className="modset-row-meta">
                    Last changed by {m.updated_by} · {new Date(m.updated_at).toLocaleString()}
                  </div>
                )}
              </div>
              <button
                type="button"
                className={`modset-toggle ${enabled ? "on" : "off"}`}
                disabled={busy}
                onClick={() => onToggle(m.module_key, enabled)}
                aria-pressed={enabled}
                title={enabled ? "Click to disable" : "Click to enable"}
              >
                {enabled ? <FaToggleOn /> : <FaToggleOff />}
                <span>{busy ? "…" : enabled ? "Enabled" : "Disabled"}</span>
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
